export default __webpack_public_path__ + "static/media/home_protfolios_animation_2.6898e4ff.jpg";